import $ from 'jquery';
import stage_language from './stage-language';

/**
 * Forms
 *
 * @description Handles form related stuff.
 * @note Master.js searches for certain css-classes and loads this module. If you add new forms, remember to add the css-class to master.js
 */

const forms = {
  init: function() {
    const forms = document.getElementsByClassName('kayttoauto-form');

    if (forms.length > 0) {
      for (let i = 0; i < forms.length; i++) {

        //Phone number input custom placeholder
        const phoneInput = forms[i].querySelector('input[name="phone"]');

        if (typeof phoneInput !== 'undefined' && phoneInput !== null) {
          phoneInput.addEventListener('input', function(event) {
            if (phoneInput.value.length > 0) {
              phoneInput.classList.add('not-empty');
            }
            else {
              phoneInput.classList.remove('not-empty');
            }
          });
        }
      }
    }

    const $submitButton = $('.service-reservation-form button[type="submit"]');

    $('.service-reservation-form').on('submit', function(e) {
      e.preventDefault();
      const license = $(e.target).find('.rekno').val();
      $submitButton.toggleClass('show-spinner',true);

      $.get('/stage-ajax/checkServiceStatus', { 'license': license }, function(data) {
        $submitButton.toggleClass('show-spinner',false);
        if (data[0]) {
          $(e.target).find('.statustext').remove();
          $(e.target).append('<div class="statustext">' + data[0] + '</div>');
        }
        else if (data[1]) document.location.href = data[1];
        else window.location = stage_language === 'fi' ? 'http://online.kayttoauto.fi/booking/fi/service/?reg=' + license : 'http://online.kayttoauto.fi/booking/sv/service/?reg=' + license;
      }, 'json')
    });
  }
};

export default forms;
